import React, { useState, useEffect, useRef } from 'react';
import axios from './lib/axiosClient';

const S = {
  bg: '#0f0f11', panel: '#16161a', border: '#2a2a35', text: '#f0f0f2',
  muted: '#7a7a8a', amber: '#f5a623', green: '#3ecf8e', red: '#e8484a', blue: '#4f8ef7',
};
const inp = { width: '100%', padding: '9px 12px', background: '#1a1a22', border: '1px solid ' + S.border, borderRadius: 8, color: S.text, fontSize: 14, boxSizing: 'border-box', outline: 'none' };
const STATUS_COLORS = { pending: S.amber, ordered: S.blue, received: S.green, cancelled: S.red };
const STATUS_LABELS = { pending: '⏳ Pending', ordered: '📦 Ordered', received: '✅ Received', cancelled: '❌ Cancelled' };

function VendorDropdown({ vendors, value, onChange }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ref = useRef();
  const selected = vendors.find(v => String(v.id) === String(value));
  const filtered = vendors.filter(v => !search || v.name.toLowerCase().includes(search.toLowerCase()) || (v.contact_name||'').toLowerCase().includes(search.toLowerCase()));

  useEffect(() => {
    function handleClick(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <div onClick={() => setOpen(!open)} style={{ ...inp, cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#1a1a22' }}>
        {selected ? (
          <div>
            <div style={{ fontWeight: 700, fontSize: 14 }}>{selected.name}</div>
            {selected.contact_name && <div style={{ fontSize: 11, color: S.muted }}>{selected.contact_name}</div>}
          </div>
        ) : <span style={{ color: S.muted }}>Select vendor...</span>}
        <span style={{ color: S.muted, fontSize: 12 }}>{open ? '▲' : '▼'}</span>
      </div>
      {open && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: S.panel, border: '1px solid ' + S.border, borderRadius: 10, zIndex: 100, boxShadow: '0 8px 24px rgba(0,0,0,0.5)', marginTop: 4 }}>
          <div style={{ padding: 8 }}>
            <input autoFocus value={search} onChange={e => setSearch(e.target.value)} placeholder="🔍 Search vendors..." style={{ ...inp, padding: '7px 10px', fontSize: 13 }} />
          </div>
          <div style={{ maxHeight: 220, overflowY: 'auto' }}>
            <div onClick={() => { onChange(''); setOpen(false); setSearch(''); }}
              style={{ padding: '10px 14px', cursor: 'pointer', color: S.muted, fontSize: 13, borderBottom: '1px solid ' + S.border }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(245,166,35,0.08)'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
              No vendor
            </div>
            {filtered.length === 0 ? (
              <div style={{ padding: '16px', textAlign: 'center', color: S.muted, fontSize: 13 }}>No vendors found</div>
            ) : filtered.map(v => (
              <div key={v.id} onClick={() => { onChange(v.id); setOpen(false); setSearch(''); }}
                style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid #1a1a22', background: String(v.id) === String(value) ? 'rgba(245,166,35,0.08)' : 'transparent' }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(245,166,35,0.08)'}
                onMouseLeave={e => e.currentTarget.style.background = String(v.id) === String(value) ? 'rgba(245,166,35,0.08)' : 'transparent'}>
                <div style={{ fontWeight: 700, fontSize: 14, color: S.text }}>{v.name}</div>
                <div style={{ fontSize: 11, color: S.muted, marginTop: 2 }}>
                  {[v.contact_name, v.phone, v.email].filter(Boolean).join(' · ')}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default function PurchaseOrders() {
  const [orders, setOrders] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const [filterStatus, setFilterStatus] = useState('all');
  const [form, setForm] = useState({ vendor_id: '', notes: '', expected_date: '', items: [{ name: '', sku: '', qty: 1, unit_cost: '' }] });

  useEffect(() => { load(); }, []);

  async function load() {
    setLoading(true);
    try {
      const [pos, vs] = await Promise.all([axios.get('/api/purchase-orders'), axios.get('/api/vendors')]);
      setOrders(pos.data.purchase_orders || []);
      setVendors(vs.data.vendors || []);
    } catch(e) {}
    setLoading(false);
  }

  async function save() {
    const validItems = form.items.filter(i => i.name && i.qty && i.unit_cost);
    if (!validItems.length) { alert('Add at least one item with name, qty and cost'); return; }
    try {
      await axios.post('/api/purchase-orders', { ...form, items: validItems.map(i => ({...i, qty: parseInt(i.qty), unit_cost: parseFloat(i.unit_cost)})) });
      setShowModal(false);
      setForm({ vendor_id: '', notes: '', expected_date: '', items: [{ name: '', sku: '', qty: 1, unit_cost: '' }] });
      load();
    } catch(e) {}
  }

  async function updateStatus(id, status) {
    await axios.put('/api/purchase-orders/' + id, { status }); load();
  }

  async function del(id) {
    if (!window.confirm('Delete this PO?')) return;
    await axios.delete('/api/purchase-orders/' + id); load();
  }

  function addItem() { setForm(f => ({ ...f, items: [...f.items, { name: '', sku: '', qty: 1, unit_cost: '' }] })); }
  function removeItem(i) { setForm(f => ({ ...f, items: f.items.filter((_, idx) => idx !== i) })); }
  function updateItem(i, key, val) { setForm(f => ({ ...f, items: f.items.map((item, idx) => idx === i ? {...item, [key]: val} : item) })); }

  const total = form.items.reduce((s, i) => s + (parseFloat(i.qty||0) * parseFloat(i.unit_cost||0)), 0);
  const filtered = filterStatus === 'all' ? orders : orders.filter(o => o.status === filterStatus);

  const summary = {
    total: orders.length,
    pending: orders.filter(o => o.status === 'pending').length,
    ordered: orders.filter(o => o.status === 'ordered').length,
    received: orders.filter(o => o.status === 'received').length,
  };

  return (
    <div style={{ padding: 24, background: S.bg, minHeight: '100vh', color: S.text }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800 }}>📋 Purchase Orders</div>
          <div style={{ fontSize: 13, color: S.muted, marginTop: 2 }}>Order inventory from your vendors</div>
        </div>
        <button onClick={() => setShowModal(true)} style={{ padding: '9px 20px', background: S.amber, color: '#000', border: 'none', borderRadius: 10, fontWeight: 800, cursor: 'pointer', fontSize: 14 }}>+ New Order</button>
      </div>

      {/* Summary cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 12, marginBottom: 20 }}>
        {[['Total POs', summary.total, S.text], ['Pending', summary.pending, S.amber], ['Ordered', summary.ordered, S.blue], ['Received', summary.received, S.green]].map(([label, val, color]) => (
          <div key={label} style={{ background: S.panel, border: '1px solid ' + S.border, borderRadius: 12, padding: '14px 16px' }}>
            <div style={{ fontSize: 10, fontWeight: 600, color: S.muted, textTransform: 'uppercase', letterSpacing: '.1em', marginBottom: 6 }}>{label}</div>
            <div style={{ fontSize: 24, fontWeight: 900, color }}>{val}</div>
          </div>
        ))}
      </div>

      {/* Filter tabs */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {['all','pending','ordered','received','cancelled'].map(s => (
          <button key={s} onClick={() => setFilterStatus(s)}
            style={{ padding: '6px 14px', borderRadius: 8, border: 'none', cursor: 'pointer', fontWeight: 700, fontSize: 12, background: filterStatus === s ? (STATUS_COLORS[s] || S.amber) : S.panel, color: filterStatus === s ? (s === 'all' ? '#000' : '#fff') : S.muted }}>
            {s === 'all' ? 'All' : STATUS_LABELS[s]}
          </button>
        ))}
      </div>

      {/* Orders list */}
      {loading ? <div style={{ color: S.muted, padding: 40, textAlign: 'center' }}>Loading...</div>
      : filtered.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, color: S.muted }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>📋</div>
          <div style={{ fontSize: 16, fontWeight: 600 }}>No purchase orders</div>
          <div style={{ fontSize: 13, marginTop: 4 }}>Click "+ New Order" to create one</div>
        </div>
      ) : filtered.map(po => (
        <div key={po.id} style={{ background: S.panel, border: '1px solid ' + S.border, borderRadius: 14, marginBottom: 12, overflow: 'hidden' }}>
          <div style={{ padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 14, cursor: 'pointer' }} onClick={() => setExpanded(expanded === po.id ? null : po.id)}>
            <span style={{ fontSize: 11, fontWeight: 700, padding: '4px 10px', borderRadius: 8, background: STATUS_COLORS[po.status] + '20', color: STATUS_COLORS[po.status], whiteSpace: 'nowrap' }}>{STATUS_LABELS[po.status]}</span>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 800, fontSize: 15, color: S.text }}>{po.vendors?.name || '—'}</div>
              <div style={{ fontSize: 11, color: S.muted, marginTop: 2 }}>
                Created {po.created_at?.split('T')[0]}
                {po.expected_date ? ' · Expected ' + po.expected_date : ''}
                {po.notes ? ' · ' + po.notes : ''}
              </div>
            </div>
            <div style={{ textAlign: 'right', flexShrink: 0 }}>
              <div style={{ fontWeight: 900, fontSize: 18, color: S.amber }}>${parseFloat(po.total||po.total_cost||0).toFixed(2)}</div>
            </div>
            <div style={{ color: S.muted, fontSize: 13 }}>{expanded === po.id ? '▲' : '▼'}</div>
          </div>
          {expanded === po.id && (
            <div style={{ borderTop: '1px solid ' + S.border, padding: '16px 20px' }}>
              {/* Status buttons */}
              <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
                <span style={{ fontSize: 12, color: S.muted, alignSelf: 'center', marginRight: 4 }}>Update status:</span>
                {['pending','ordered','received','cancelled'].map(s => (
                  <button key={s} onClick={() => updateStatus(po.id, s)}
                    style={{ padding: '6px 14px', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 12, cursor: 'pointer', background: po.status === s ? STATUS_COLORS[s] : S.bg, color: po.status === s ? '#fff' : S.muted }}>
                    {STATUS_LABELS[s]}
                  </button>
                ))}
                <button onClick={() => del(po.id)} style={{ marginLeft: 'auto', padding: '6px 14px', background: 'rgba(232,72,74,0.1)', border: '1px solid rgba(232,72,74,0.2)', borderRadius: 8, color: S.red, cursor: 'pointer', fontWeight: 600, fontSize: 12 }}>🗑 Delete</button>
              </div>
            </div>
          )}
        </div>
      ))}

      {/* New Order Modal */}
      {showModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div style={{ background: S.panel, border: '1px solid ' + S.border, borderRadius: 16, width: '100%', maxWidth: 640, maxHeight: '92vh', overflow: 'auto' }}>
            {/* Modal header */}
            <div style={{ padding: '20px 24px', borderBottom: '1px solid ' + S.border, display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, background: S.panel, zIndex: 1 }}>
              <div style={{ fontSize: 17, fontWeight: 800 }}>📋 New Purchase Order</div>
              <button onClick={() => setShowModal(false)} style={{ background: 'none', border: 'none', color: S.muted, fontSize: 22, cursor: 'pointer' }}>×</button>
            </div>

            <div style={{ padding: '20px 24px' }}>
              {/* Vendor */}
              <div style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: S.muted, textTransform: 'uppercase', letterSpacing: '.08em', marginBottom: 6 }}>Vendor</div>
                <VendorDropdown vendors={vendors} value={form.vendor_id} onChange={v => setForm(f=>({...f, vendor_id: v}))} />
                {vendors.length === 0 && <div style={{ fontSize: 12, color: S.amber, marginTop: 6 }}>⚠ No vendors yet — add vendors first</div>}
              </div>

              {/* Date & Notes */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 16 }}>
                <div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: S.muted, textTransform: 'uppercase', letterSpacing: '.08em', marginBottom: 6 }}>Expected Date</div>
                  <input type="date" value={form.expected_date} onChange={e=>setForm(f=>({...f,expected_date:e.target.value}))} style={inp}/>
                </div>
                <div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: S.muted, textTransform: 'uppercase', letterSpacing: '.08em', marginBottom: 6 }}>Notes</div>
                  <input value={form.notes} onChange={e=>setForm(f=>({...f,notes:e.target.value}))} placeholder="e.g. Rush order, Net 30..." style={inp}/>
                </div>
              </div>

              {/* Items table */}
              <div style={{ marginBottom: 8 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: S.muted, textTransform: 'uppercase', letterSpacing: '.08em', marginBottom: 10 }}>Order Items</div>
                {/* Table header */}
                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 90px 100px 32px', gap: 8, marginBottom: 6, padding: '0 2px' }}>
                  {['Item Name', 'SKU', 'Qty', 'Unit Cost', ''].map(h => (
                    <div key={h} style={{ fontSize: 10, fontWeight: 700, color: S.muted, textTransform: 'uppercase' }}>{h}</div>
                  ))}
                </div>
                {form.items.map((item, i) => (
                  <div key={i} style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 90px 100px 32px', gap: 8, marginBottom: 8, alignItems: 'center' }}>
                    <input value={item.name} onChange={e=>updateItem(i,'name',e.target.value)} placeholder="Product name..." style={inp}/>
                    <input value={item.sku} onChange={e=>updateItem(i,'sku',e.target.value)} placeholder="SKU" style={inp}/>
                    <input type="number" min="1" value={item.qty} onChange={e=>updateItem(i,'qty',e.target.value)} placeholder="1" style={inp}/>
                    <div style={{ position: 'relative' }}>
                      <span style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: S.muted, fontSize: 13 }}>$</span>
                      <input type="number" min="0" step="0.01" value={item.unit_cost} onChange={e=>updateItem(i,'unit_cost',e.target.value)} placeholder="0.00" style={{ ...inp, paddingLeft: 22 }}/>
                    </div>
                    <button onClick={()=>removeItem(i)} disabled={form.items.length === 1}
                      style={{ background:'none', border:'none', color: form.items.length === 1 ? S.border : S.red, cursor: form.items.length === 1 ? 'default' : 'pointer', fontSize:18, padding: 0 }}>×</button>
                  </div>
                ))}

                {/* Row subtotals */}
                {form.items.some(i => i.name && i.qty && i.unit_cost) && (
                  <div style={{ marginTop: 4, marginBottom: 12 }}>
                    {form.items.filter(i => i.name && i.unit_cost).map((item, i) => (
                      <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: S.muted, padding: '2px 4px' }}>
                        <span>{item.name} × {item.qty}</span>
                        <span>${(parseFloat(item.qty||0)*parseFloat(item.unit_cost||0)).toFixed(2)}</span>
                      </div>
                    ))}
                  </div>
                )}

                <button onClick={addItem} style={{ padding:'7px 16px', background:'transparent', border:'1px dashed '+S.border, borderRadius:8, color:S.muted, cursor:'pointer', fontSize:13, marginTop: 4 }}>+ Add Item</button>
              </div>

              {/* Total */}
              {total > 0 && (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 16px', background: 'rgba(245,166,35,0.08)', border: '1px solid rgba(245,166,35,0.2)', borderRadius: 10, marginBottom: 20, marginTop: 12 }}>
                  <span style={{ fontSize: 14, fontWeight: 700, color: S.text }}>Order Total</span>
                  <span style={{ fontSize: 22, fontWeight: 900, color: S.amber }}>${total.toFixed(2)}</span>
                </div>
              )}

              {/* Actions */}
              <div style={{ display: 'flex', gap: 10 }}>
                <button onClick={() => setShowModal(false)} style={{ flex:1, padding:13, background:'transparent', color:S.muted, border:'1px solid '+S.border, borderRadius:10, fontWeight:600, cursor:'pointer' }}>Cancel</button>
                <button onClick={save} style={{ flex:2, padding:13, background:S.amber, color:'#000', border:'none', borderRadius:10, fontWeight:800, cursor:'pointer', fontSize:15 }}>Create Order</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
